//BASE Url
export const BASE_URL: string = 'api/ComponentForecast'

export class fleetDealerVm {

    dealershipid: number
    dealershipName: string
    Owner: number
    dealergroupID:number
    userID:number
    userName:string
}

export class CusInfoForeDealerVM {
    DealerId: number
    CustomerId: number
    custid: string
    cust_name: string
}

export class JobsiteInfoForCustomerVM {
    crsf_auto: number
    CustomerId: number
    site_name: string
}

export class EquipmentVM {
    Serial: string
    Unit: string
}

export class CompenentForecastVM {
   
    serialno: number
    unitino: string
    model: string
    make: string
    type: string
    sitename: string
    comaptyType: string
    compart: string
    Customer: string
    QuaterList: NewReplacementDateList[]
    OEMpart:string
    MFRpart:string
}

export class NewReplacementDateList {
    rebuildDate: Date
    month_val: string
    year_val: string
    quater_year: string
    isReplaceDate: number
    ShouldHighLight:number

}
export class ForecastVM{
    data:CompenentForecastVM[]
    timePeriod:string[]
}
export class equipmentListVM{
      equipmentid_auto:number
      serialno :string
      unitno :string
      userID :number
}
export class userID{
    userID:number
}

export class InspectionReportingContainers{
    isShowUndercarriageTable:boolean
    isShowUndercarriageTab:boolean
    isShowGetImplementTable:boolean
    isShowgetImplementTab:boolean
    isShowDigitalFormTab:boolean
    isShowDigitalFormTable:boolean
}
